

export enum ClientRelationshipClassificationCodes {
    Society = 1,
    EconomicGroup = 2,
    RelatedPeople = 3,
    MoreSureties = 4,
    CoOwners = 5,
    Titularity = 6
}


export enum ClientRelationshipCodes {
    Owner = 1,
    CoOwner = 2,
    Sureties = 3,
    Associate = 5,
    President = 6,
    Member = 8,
    Subsidiary = 9,
    Fiance = 10,
    Cohabitant = 11,
    Shareholder = 13,
    LegalRepresentative = 18,
    Attorney = 19,
    JointlyAndSeverally = 20,
    Treasurer = 21,
    Secretary = 22,
    AssociateManager = 23,
    Admin = 24,
    Severally = 25
}